<template>
    <div class="dlist">

    <el-dialog
        width="70%"
      :visible="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="cancel"
    >
        <div slot="title">
            <span>设备列表</span>
            <span style="margin-left:20px;">
                <el-input v-model="keyword" size="mini" style="width:40%;" placeholder="搜索"></el-input>
            </span>
        </div>
        <el-table ref="multipleTable"
            :data="tableData"
            row-key="deviceId"
            @selection-change="selectRow"
            @select="checkRow">
            <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
            <el-table-column align="center" prop="name" label="名称"></el-table-column>
            <el-table-column align="center" prop="area" label="设备所在地"></el-table-column>
            <el-table-column align="center" prop="room" label="所属机房"></el-table-column>
            <el-table-column align="center" prop="createNum" label="创建个数" width="100">
                <template v-slot="{row}">
                    <el-input v-model="row.createNum" type="number" size="mini"
                        @input="numChange(row)"></el-input>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="fy"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10,20,30,40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElement"
        ></el-pagination>
        <el-row style="text-align:right;margin-top: 30px;">
            <el-button @click="cancel" size="mini">取消</el-button>
            <el-button type="primary" :disabled="selects.length == 0" @click="save" size="mini">确定</el-button>

        </el-row>
    </el-dialog>

    <ins-need-del
        v-if="insNeedDelShow"
        :visible="insNeedDelShow"
        :params="delParams"
        @dialogClose="insDelClose"/>
    </div>
</template>
<script>
import InsNeedDel from './InsNeedDel'
export default {
    components: {InsNeedDel},
    name: 'DragDeviceList',
    props: {
        visible: {
            type: Boolean
        },
        selectedRows: {
            type: Array,
            default: ()=>{
                return []
            }
        },
        currentModule: {
            type: Object,
            default: ()=>{
                return {}
            }
        }
    },
    data: vm=>({
        dataList: [],
        selects: [],
        insNeedDelShow: false, //显示需要删除的实例弹框
        delParams: {}, //需要删除的实例 请求参数
        currentPage: 1,
        pageSize: 10,
        keyword: '',
        totalElement: 0,
        delInsIds: []
    }),
    computed: {
        tableData(){
            let datas = []
            if(this.keyword){
                datas = this.filterArr(this.keyword, this.dataList)
            }else{
                datas = this.dataList
            }
            this.totalElement = datas.length
            let start = (this.currentPage - 1) * this.pageSize
            let end = this.currentPage * this.pageSize
            let arr = datas.slice(start, end)
            return arr
        },
    },
    created(){
        this.findAll()
    },
    watch: {
        dataList(){
            this.$nextTick(()=>{
                const _this = this
                if(this.selectedRows.length > 0){
                    this.selectedRows.forEach( row => {
                        const rowIndex = _this.dataList.findIndex(data => data.deviceId == row.deviceId)
                        _this.$refs.multipleTable.toggleRowSelection(_this.dataList[rowIndex])

                        _this.dataList[rowIndex].createNum = row.createNum
                        _this.dataList[rowIndex].oldCreateNum = row.createNum
                    })


                }
            })
        }
    },
    methods: {
        handleSizeChange(val){
            this.pageSize = val
        },
        handleCurrentChange(val){
            this.currentPage = val
        },
        findAll() {
            this.$axios.get(this.baseUrl3 + "management3/device/findAll")
            .then(({ data: { msg, data, code } }) => {
                if(code == 20000){
                    // this.dataList = data
                    data.forEach((dataItem)=>{
                        dataItem.createNum = 1
                        dataItem.deviceId = dataItem.id
                        dataItem.id = ''
                    })
                    this.dataList = data
                }else{
                    this.$message({ showClose: true, message: msg, type: "error" });
                    console.log(msg);
                }
            });
        },
        selectRow(val){
            this.selects = val
        },
        checkRow(selection, row){
            // row是取消勾选还是选中,如果取消，提示慎重删除
            const existSelected = this.selectedRows.some(sr => sr.deviceId == row.deviceId)
            if(!existSelected){
                return
            }
            const checked = selection.some(selected => selected.deviceId == row.deviceId)
            if(!checked){
                this.$message.warning('取消勾选后，该设备上的实例将被删除，请慎重操作！')
            }
        },
        numChange(row){
            if(this.currentModule.arrangeId){
                if(row.oldCreateNum > row.createNum){
                    this.delParams = {
                        deviceId: row.deviceId,
                        deviceName: row.name,
                        oldNum: parseInt(row.oldCreateNum), //原来设备数量
                        newNum: parseInt(row.createNum), //现在设备数量
                        arrangeId: this.currentModule.arrangeId, //编排id
                        moduleType: this.currentModule.moduleType,
                        moduleVersion: this.currentModule.moduleVersion,
                        group: this.currentModule.group, //是否是网元
                    }
                    this.insNeedDelShow = true
                }
            }else{
                if(row.createNum == 0){
                    this.$refs.multipleTable.toggleRowSelection(row)
                    row.oldCreateNum = 1
                    row.createNum = 1
                }
            }

        },
        // 删除实例后关闭弹框
        insDelClose(val){
            this.insNeedDelShow = false
            let rowIndex = this.dataList.findIndex(data => data.deviceId == this.delParams.deviceId)

            if(val === false){
                this.dataList[rowIndex].createNum = this.delParams.oldNum
                this.delParams = {}
                return
            }else{
                this.dataList[rowIndex].oldCreateNum = this.delParams.newNum
                if(this.delParams.newNum == 0){
                    this.$refs.multipleTable.toggleRowSelection(this.dataList[rowIndex])
                    this.dataList[rowIndex].oldCreateNum = 1
                    this.dataList[rowIndex].createNum = 1
                }
                this.delInsIds = this.delInsIds.concat(val)
            }
            // this.dataList[rowIndex].oldCreateNum = this.delParams.newNum
        },
        save(){
            let arr = this.selects.filter(s => s.createNum > 0)
            // this.$emit('deviceCallback', arr)
            this.$emit('deviceCallback', {
                deviceInstalleds: arr,
                delInsIds: this.delInsIds
            })
        },
        cancel(){
            this.$emit('deviceCallback', false)
        },
    }
}
</script>
<style scoped>
.dlist >>> .el-dialog{
    margin-top: 0 !important;
}
.dlist >>> .el-dialog__body{
    padding-top: 0 !important;
}
</style>
